__turbopack_context__.v({
  "className": "instrument_sans_f3137f1b-module__YGvtFq__className",
});
